import type {
  OpenAILegacyToolFollowUpPromptInput,
  ProviderToolFollowUpPromptInput,
} from "./types";
import { getBrandContext } from "../types";

export function buildOpenAILegacyToolFollowUpPrompt(
  input: OpenAILegacyToolFollowUpPromptInput
): string {
  const brand = getBrandContext(input.toolPolicy);
  const previousResponse = `Previous response: ${input.previousResponse}`;
  const instruction = `Now provide the final JSON modification using these results. For logos, choose a candidate only when matchedCompanyName is clearly the requested brand; use matchedTicker as supporting context only, never as sole evidence. On each selected create shape set logoCompanyName to result.companyName and logoCandidateRef to candidate.logoCandidateRef exactly (do not paste URLs). If no candidate is reliable, create a clear text placeholder using result.companyName. For ${brand.researchToolName} results, use the returned data to populate slide content with accurate, real information.`;
  return `${previousResponse}

Tool results:
${input.serializedToolResults}

${instruction}`;
}

export function buildProviderToolResultsFollowUpPrompt(
  input: ProviderToolFollowUpPromptInput
): string {
  const instruction =
    "Now provide the final JSON modification using these results. Use the real data to populate slide content accurately.";
  return `Tool results:
${input.serializedToolResults}

${instruction}`;
}
